import { TextField } from '@flos/react-ui';
import { useHippoText } from '../../../../hooks/useHippoText';
import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { useSaveCoverableInformation } from '../../../../hooks/useSaveCoverableInformation';
import { type CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { useState } from 'react';
import _ from 'lodash';
import { track } from '../../../../utils/trackingUtil';

const NameOfChild = ({ goNext }: { goNext: () => void }): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [coverables, setCoverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const childCoverables = coverables.childAccidents ?? [];
    const coverableIndex = childCoverables?.findIndex(
        (coverable) => coverable.fixedId === currentProduct.fixedId
    );
    const [firstName, setFirstName] = useState<string>(
        childCoverables[coverableIndex].firstName ?? ''
    );
    const [lastName, setLastName] = useState<string>(
        childCoverables[coverableIndex].lastName ?? ''
    );
    const [isLoading, setIsLoading] = useState(false);

    const isValid = !_.isEmpty(firstName) && !_.isEmpty(lastName);

    const onNext = (): void => {
        setIsLoading(true);
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            childAccident: {
                publicId: childCoverables[coverableIndex].publicId,
                fixedId: childCoverables[coverableIndex].fixedId,
                firstName: childCoverables[coverableIndex].firstName,
                lastName: childCoverables[coverableIndex].lastName
            },
            productToUpdate: currentProduct.flavourName
        };

        void saveCoverableInformation(updatedCoverable).then(() => {
            track(`${updatedCoverable.productToUpdate}CoverableInformationNameOfChild`, [
                { firstName: updatedCoverable.childAccident?.firstName },
                { lastName: updatedCoverable.childAccident?.lastName }
            ]);
            goNext();
            setIsLoading(false);
        });
    };

    const handleNameOfChildBlur = (): void => {
        if (!childCoverables || coverableIndex === undefined || !firstName || !lastName) {
            return;
        }
        const updatedCoverables = [...childCoverables];

        updatedCoverables[coverableIndex] = {
            ...updatedCoverables[coverableIndex],
            firstName,
            lastName,
            name: firstName
        };

        setCoverables((prev) => ({
            ...prev,
            childAccidents: updatedCoverables
        }));
    };

    return (
        <WizardPagetemplate
            onNext={onNext}
            hidePrevious
            disableNext={isLoading || !isValid}
            isNextLoading={isLoading}
        >
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-CHILD-NAME-HEADER')}
            >
                <div className="u-display-flex u-flex-items-stretch u-flex-items-start u-gap-3 u-flex-row@xs u-flex-column">
                    <TextField
                        label={getHippoText(
                            'DSS-COVERABLE-INFORMATION-STEP-CHILD-FIRST-NAME-INPUT'
                        )}
                        value={firstName}
                        onBlur={handleNameOfChildBlur}
                        onChange={(event) => {
                            setFirstName(event.target.value);
                        }}
                        minLength={1}
                        disabled={isLoading}
                    />
                    <TextField
                        label={getHippoText('DSS-COVERABLE-INFORMATION-STEP-CHILD-LAST-NAME-INPUT')}
                        value={lastName}
                        onBlur={handleNameOfChildBlur}
                        onChange={(event) => {
                            setLastName(event.target.value);
                        }}
                        minLength={1}
                        disabled={isLoading}
                    />
                </div>
            </CoverableDetailsTemplate>
        </WizardPagetemplate>
    );
};

export default NameOfChild;
